import { Injectable, inject } from '@angular/core';

import { AccessControlService } from './access-control.srvice';

@Injectable({
  providedIn: 'root',
})
export class LoginAuthGuard {
  accessControl = inject(AccessControlService);

  canActivate(): boolean {
    if (!this.accessControl.redirectToHome()) return false;
    return true;
  }
}
